import * as React from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridColDef, GridRowSelectionModel } from "@mui/x-data-grid";

type DataGridDemoProps = {
  rows: any[];
  columns: GridColDef<any>[];
  pageSize?: number;
  checkboxSelection?: boolean;
  disableRowSelectionOnClick?: boolean;
  getRowId?: (row: any) => any;
  searchQuery?: string;
  setSearchQuery?: (query: string) => void;
  onSelectionModelChange?: (selectedIds: any[]) => void;
  density?: 'compact' | 'standard' | 'comfortable';
};

const GridTable: React.FC<DataGridDemoProps> = ({
  rows,
  columns,
  pageSize = 10,
  checkboxSelection = false,
  disableRowSelectionOnClick = true,
  getRowId,
  searchQuery = '',
  onSelectionModelChange,
  density = 'compact',
}) => {
  const customLocaleText = {
    noRowsLabel: "There are no records to display",
  };

  const filteredRows = rows?.filter((row) =>
    columns.some((column) => {
      const value = row[column.field];
      return value && value.toString().toLowerCase().includes(searchQuery.toLowerCase());
    })
  );

  const handleRowSelectionModelChange = (
    rowSelectionModel: GridRowSelectionModel
  ) => {
    if (onSelectionModelChange) {
      onSelectionModelChange([...rowSelectionModel]);
    }
  };

  return (
    <Box>
      <DataGrid
        getRowId={getRowId}
        rows={filteredRows}
        columns={columns}
        density={density}
        autoHeight
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: pageSize ? pageSize : 5,
            },
          },
        }}
        pageSizeOptions={[5, 10, 25, 50]}
        localeText={customLocaleText}
        checkboxSelection={checkboxSelection}
        disableRowSelectionOnClick={disableRowSelectionOnClick}
        onRowSelectionModelChange={handleRowSelectionModelChange}
        sx={{
          '& .MuiDataGrid-cell:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-cell:focus-within': {
            outline: 'none',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 'bold',
          }
        }}
      />
    </Box>
  );
};

export default GridTable;
